import {
  Box, ColouredTile, ListItem, StatusBadge, Text,
} from '@domain-group/suit-theme'

import useCampaignPortalSync from '@hooks/useCampaignPortalSync'
import { generateUrls } from '@hooks/useCampaignPortal'

import type { CampaignPortalSyncModel } from '@models/types'
import { generateRedirectUrl } from '@domain-group/javascript-utils'

const tileColor = {
  'export-false': 'red',
  'export-true': 'blue',
  'import-false': 'red',
  'import-true': 'lightGrey',
}

const PortalSyncListItem = (props: { campaignPortalSync: CampaignPortalSyncModel }) => {
  const { campaignPortalSync } = props

  const campaignPortalSyncPayload = useCampaignPortalSync(campaignPortalSync)
  const {
    // @ts-expect-error TS2339
    campaign: { address, id, suburb_name },
    campaignPortalSync: {
      portal_id,
      success,
      sync_type,
    },
    lastSyncDateStr,
    portal,
  } = campaignPortalSyncPayload

  const queryParams = [
    `redirect=${generateRedirectUrl()}`,
    'showModal=CampaignPortalSyncDetailsModal',
    `showModalPayload=${encodeURIComponent(JSON.stringify({ campaignPortalSync }))}`,
  ]

  const portalsUrls = generateUrls(
    {},
    {
      prefixRoute: `campaigns/${id}/edit`,
      queryString: `?${queryParams.join('&')}`,
    },
  )

  const { editPortalsUrl } = portalsUrls

  return (
    <ListItem
      boxProps={{
        as: 'a',
        alignItems: 'center',
        borderBottom: '1px dashed',
        padding: 'large',
      }}
      href={editPortalsUrl}
      showAngleIcon
    >
      <ColouredTile
        boxProps={{ height: 20, width: 60 }}
        // @ts-expect-error TS7053
        color={tileColor[`${sync_type}-${success}`]}
      >
        {sync_type}
      </ColouredTile>

      <Box flexDirection="column" marginLeft="large">
        <Text fontSize="small">{address}, {suburb_name}</Text>

        <Text
          color="bodyFontLightColor"
          fontSize="xsmall"
          marginTop="small"
          maxWidth={[150, 150, 150, 250]}
          variant="ellipsis"
        >
          {/*
           // @ts-expect-error TS2339 */}
          {portal.title || `Portal #${portal_id}`}
        </Text>
      </Box>

      <Box flexDirection="column" justifyContent="flex-end" marginLeft="auto" textAlign="right">
        <Text>
          <StatusBadge
            color={success ? 'green' : 'red'}
            text={success ? 'Success' : 'Failed'}
          />
        </Text>

        <Text
          color="bodyFontLightColor"
          display={['none', 'inline-block']}
          fontSize="xsmall"
          marginTop="small"
        >
          {lastSyncDateStr || 'Not Synced'}
        </Text>
      </Box>
    </ListItem>
  )
}

export default PortalSyncListItem
